import { create } from 'zustand';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

interface AlertState {
  isOpen: boolean;
  message: string;
  type: AlertType;
  showAlert: (message: string, type: AlertType) => void;
  hideAlert: () => void;
}

export const useAlertStore = create<AlertState>((set) => ({
  isOpen: false,
  message: '',
  type: 'info',
  showAlert: (message: string, type: AlertType) => 
    set({ isOpen: true, message, type }),
  hideAlert: () => 
    set({ isOpen: false }),
})); 